import { api } from '@fsd/shared/api';
import type { GlobalAlertsResponse } from '../model/types';

export const getGlobalAlerts = async () => {
  const response = await api.get<GlobalAlertsResponse>(
    '/api/v1/general/user/fill-errors/summary/'
  );

  return response.data;
};